/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, MITSUB_S){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';
	const $path = location.pathname;

	// もっと見る
	const newsListMore = () => {
		let $newsList = $('.js-newsList li');
		if($('.news-idx').length) {
			$newsList = $('.js-newsList-item.is-active .js-newsList li');
		}
		if($newsList.length) {
			let startCnt = 25, endCnt = 30;
			const addResult = () => {
				for(let i=startCnt; i<endCnt; i++) {
					if($newsList.eq(i).length) {
						$newsList.eq(i).addClass(v);
						if($newsList.length === $('.js-newsList li.is-visible').length) {
							$('.js-newsList-more').removeClass(v);
							break;
						} else {
							$('.js-newsList-more').addClass(v);
						}
					} else {
						$('.js-newsList-more').removeClass(v);
						break;
					}
				}
			};
			// 最初の30件表示
			$newsList.slice(0, 30).addClass(v);
			// 30件以下の場合moreボタン非表示
			if($newsList.length <= 30) {
				$('.js-newsList-more').removeClass(v);
			} else {
				$('.js-newsList-more').addClass(v);
			}
			// moreボタン押下で5件ずつ追加表示
			$('.js-newsList-more').on('click', () => {
				startCnt += 5; endCnt += 5;
				addResult();
			});
		} else {
			$('.js-newsList-more').removeClass(v);
		}
	};

	// <ニュース一覧年号選択
	const selectYear = () => {
		let latestY = $('.rt_bn_latest_news .rt_year').text();
		let oldestY = $('.rt_bn_earliest_news .rt_year').text();
		let headDir = '/news/';
		if($path.split('/')[1] === 'en') {
			headDir = '/en/news/';
		}

		if(latestY === '') {
			let today = new Date();
			let year = today.getFullYear();
			latestY = year;
			oldestY = year;
		}

		// 年号セレクトボックス生成
		for(let i = latestY; i > oldestY-1; i--) {
			if($path.indexOf(i) !== -1) {
				$('.js-selectYear').append('<option value="'+ i +'" selected="selected">'+i+'</option>');
			} else {
				$('.js-selectYear').append('<option value="'+ i +'">'+i+'</option>');
			}
		}

		$('.js-selectYear').on('change', (e) => {
			let selectedY = $('.js-selectYear').find('option:selected').val();
			location.href = headDir + selectedY + '/';
		});


		// $('.js-news-category').on('click', (e) => {
		// 	let $this = $(e.currentTarget);
		// 	let $thisCat = $this.attr('data-name');
		// 	let $thisY = $('.js-selectYear').val();
		// 	let $href;

		// 	if($thisY === 'latest' && $thisCat === 'all') {
		// 		$href = '/news/';
		// 	} else {
		// 		if($thisCat === 'all') {
		// 			$href = '/news/'+ $thisY +'/';
		// 		} else {
		// 			if($thisY === 'latest') {
		// 				$thisY = $('.rt_bn_latest_'+ $thisCat +'_news .rt_year').eq(0).text();
		// 			}
		// 			if($thisY === '') {
		// 				let nowY = new Date().getFullYear();
		// 				$thisY = nowY;
		// 			}
		// 			$href = '/news/'+ $thisY +'/'+ $thisCat +'/';
		// 		}
		// 	}
		// 	location.href = $href;
		// });
	};

	// <ニュース一覧> カテゴリタブ切り替え
	const categoryTab = () => {
		let $hash = location.hash.replace('#', '');

		const tabChange = (_cat) => {
			$('.js-newsList-item').removeClass(a);
			$('.js-newsList-item[data-name="'+ _cat +'"]').addClass(a);

			// タブ切り替えの際に「もっと見る」ボタンをリセットする
			$('.js-newsList li').removeClass(v);
			$('.js-newsList-more').addClass(v);
			$('.js-newsList-more').off();
			newsListMore();
		}
		// PC
		$('.js-category').on('click', (e) => {
			let $this = $(e.currentTarget);
			let $thisCat = $this.attr('data-name');

			$('.js-category').removeClass(a);
			$this.addClass(a);

			tabChange($thisCat);
		});

		// TABLET&SP
		$('.js-category-select').on('change', (e) => {
			let $this = $(e.currentTarget);
			let $thisCat = $this.find('option:selected').val();

			tabChange($thisCat);
		});

		// カテゴリへのハッシュが存在した場合
		if($('.js-category[data-name="'+$hash+'"]').length) {
			$('.js-category[data-name="'+$hash+'"]').click();
			$('.js-category-select').find('option[value="'+$hash+'"]').prop('selected', true);
		}
		
	};

	// <キーワード検索>
	const keyWrodSearchResult = () => {
		let param = location.search.split('&');
		let thisKeyWord = '';
		for(let i = 0; i < param.length; i++) {
			if(param[i].indexOf('p_keyword') !== -1) {
				thisKeyWord = param[i].split('=')[1];
			}
		}
		$('.js-thisKeyword').text(decodeURI(thisKeyWord));
		$('.js-input-keyword').val(decodeURI(thisKeyWord))
	};

	// ==============================================================================
	if($path === '/news/' || $path === '/news/index.html') {
		let latestY = $('.rt_bn_latest_news .rt_year').text();
		if(location.hash !== '') {
			let $hash = location.hash;
			location.href = '/news/' + latestY + '/'+ $hash;
		} else {
			location.href = '/news/' + latestY + '/';
		}
	} else if($path === '/en/news/' || $path === '/en/news/index.html') {
		let latestY = $('.rt_bn_latest_news .rt_year').text();
		
		if(latestY === '') {
			let today = new Date();
			let year = today.getFullYear();
			latestY = year;
		}

		if(location.hash !== '') {
			let $hash = location.hash;
			location.href = '/en/news/' + latestY + '/'+ $hash;
		} else {
			location.href = '/en/news/' + latestY + '/';
		}
	} else {
		$('.js-newsList-wrap').removeClass('di_none');
	}
	if($path === '/news/search/result.html' || $path === '/en/news/search/result.html') {
		keyWrodSearchResult();
	}
	if($('.js-newsList-more')) {
		newsListMore();
	}
	if($('.js-selectYear').length) {
		selectYear();
	}
	if($('.js-category').length) {
		categoryTab();
	}


})(window.jQuery, window.MITSUB_S);
